import React, { useLayoutEffect } from 'react';
import { useActionData, useAsyncValue, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// Components Styled
import { Container } from '../NewAction/styles';

// Components
import NewWorkOrderForm from '../../../../components/forms/NewWorkOrderForm';

// types
import { formAccidentNaming } from '../../../../components/forms/AddBasicInfoAccidentForm/constants';
import { WorkOrder } from '../../../../types/workOrder';
import { roidOTSelected } from '../../../../state/actions/ui/roidOTSelectedGeneralView';
import { OrderType } from '../../../../types/orders';
import { AccidentDataNewAccident } from '../../../../types/accident';

export default function NewAccidentPage(): JSX.Element {
  const { t } = useTranslation();
  const accidentData = useActionData() as AccidentDataNewAccident;
  const loaderData = useAsyncValue() as WorkOrder;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    // ¿Hay un alta de ESTE padre? Lo dice el loader, que solo usa el borrador
    // si su `orderParentId` es el `:id` de la URL. Antes bastaba con que
    // hubiera ALGO en `new-accident-form`: el de otra OT (S4) o los restos que
    // deja esta misma pantalla al montarse un instante antes de redirigir
    // (el formulario vuelca sus valores, sin padre).
    const hasOwnDraft = !!(loaderData as { orderParentId?: string } | undefined)
      ?.orderParentId;
    if (!loaderData || (!accidentData && !hasOwnDraft)) {
      // `replace`: el rebote no queda en el historial; con un PUSH, «atrás»
      // volvía a esta URL y rebotaba otra vez (revisión de la Task 12a).
      navigate('../', { replace: true });
    }
    if (accidentData) {
      dispatch(
        roidOTSelected(
          OrderType.Accident,
          accidentData.orderParentRoid,
          accidentData.orderParentId
        )
      );
    }
  }, []);
  const onFormSubmit: SubmitHandler<WorkOrder> = async () => {
    navigate('basic-info');
  };
  return (
    <Container>
      <NewWorkOrderForm
        onFormSubmit={onFormSubmit}
        initialData={{
          ...loaderData,
        }}
        namingPersistForm={formAccidentNaming.NEW_ACCIDENT_FORM}
        titleBasicInfo={t('common:workOrder.basicInfoAccident')}
        titleDate={t('common:workOrder.accidentDate')}
        textDateHour={t('common:workOrder.accidentTime')}
        isAccident={true}
        registeredByRequired={true}
      />
    </Container>
  );
}
